import { render, staticRenderFns } from "./Seers.vue?vue&type=template&id=2bc1e8f6&"
import script from "./Seers.vue?vue&type=script&lang=js&"
export * from "./Seers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports